export default __webpack_public_path__ + "static/media/iconAddPhoto.bde22a45.svg";